module.exports = __webpack_public_path__ + "assets/img/ic-exclamation-mark.19a2c431.svg";